import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { BugReport } from '../../bug-reports/bug-report.model';

@JsonObject('UserReportsResultsResponse')
export class UserReportsResultsResponse extends ApiResultsResponse<BugReport> {

  @JsonProperty('results', [BugReport])
  override results: BugReport[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
